import {Component, input, OnChanges} from '@angular/core'
import {EChartsOption} from 'echarts'
import * as echarts from 'echarts/core'
import {EChartsType} from 'echarts/core'
import {ChartBaseComponent} from '../../components/charts/chart-base/chart-base.component'
import {NgxEchartsDirective, provideEchartsCore} from 'ngx-echarts'
import {PieChart} from 'echarts/charts'
import {GridComponent} from 'echarts/components'
import {CanvasRenderer} from 'echarts/renderers'

// @ts-expect-error Does not work atm. Looking into it.
import lang from 'echarts/lib/i18n/langFR.js'

echarts.use([PieChart,
  GridComponent, CanvasRenderer])
// FR has nice formatting for numbers.
echarts.registerLocale('FR', lang)


// Simplest form
export interface IPieInput {
  name: string
  value: number
}

@Component({
  selector: 'spb-pie',
  imports: [
    NgxEchartsDirective
  ],
  templateUrl: './pie.component.html',
  styleUrl: './pie.component.scss',
  providers: [
    provideEchartsCore({echarts}),
    // This is important so that we can viewChild<ChartBaseComponent>
    {provide: ChartBaseComponent, useExisting: PieComponent}
  ]
})
export class PieComponent extends ChartBaseComponent implements OnChanges {

  public data = input.required<IPieInput[]>()

  public option: EChartsOption = {
    series: [
      {
        type: 'pie',
        radius: ['30%', '90%'],
        label: {
          show: false
        },
        data: []
      }
    ]
  }

  // Placeholder, value set from template
  public myChart!: EChartsType

  public ngOnChanges() {
    const option: any = this.option
    option.series[0]!.data = this.data()
    // Replace to trigger updates
    this.option = {...this.option}
  }

  // Return the data url from the chart.
  protected override print(): string {
    return this.myChart.getDataURL({
      pixelRatio: 2,
      backgroundColor: '#fff'
    })
  }
}
